export default __webpack_public_path__ + "static/media/SearchIcon.b18f9909.svg";